import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { Provider } from 'react-redux';
import UserPicker from './UserPicker';
import { parseBoolean } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-case-create-user-picker',
	callback: ({ container, context, props }: any) => {
		const selectedUserId = container.getAttribute('selectedUserId') || null;
		const linkFamilyMemberSelect =
			container.getAttribute('linkFamilyMemberSelect') || null;
		const label =
			container.getAttribute('label') ||
			'component.userPicker.userIdSelectLabel';
		const isInvalid =
			parseBoolean(container.getAttribute('isInvalid')) ?? false;
		const showNote = parseBoolean(container.getAttribute('showNote')) ?? false;

		// selectLink
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserPicker
						selectedUserId={selectedUserId}
						linkFamilyMemberSelect={linkFamilyMemberSelect}
						label={label}
						isInvalid={isInvalid}
						showNote={showNote}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
